// intl-tel-input 29 supports Chrome 93+, where Object.hasOwn is not available.
if (typeof Object.hasOwn !== 'function') {
    Object.defineProperty(Object, 'hasOwn', {
        configurable: true,
        writable: true,
        value(object, property) {
            if (object === null || object === undefined) {
                throw new TypeError('Cannot convert undefined or null to object');
            }

            return Object.prototype.hasOwnProperty.call(Object(object), property);
        },
    });
}
